/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useMutation } from 'react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type { WithdrawalRequest } from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const withdraw = (
  bankUid: string,
  productUid: string,
  withdrawalRequest: WithdrawalRequest
) => {
  return customInstance<string>({
    url: `/operations/banks/${bankUid}/products/${productUid}/withdrawal`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: withdrawalRequest,
  });
};

export const getWithdrawMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdraw>>,
    TError,
    { bankUid: string; productUid: string; data: WithdrawalRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof withdraw>>,
  TError,
  { bankUid: string; productUid: string; data: WithdrawalRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof withdraw>>,
    { bankUid: string; productUid: string; data: WithdrawalRequest }
  > = (props) => {
    const { bankUid, productUid, data } = props ?? {};

    return withdraw(bankUid, productUid, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WithdrawMutationResult = NonNullable<
  Awaited<ReturnType<typeof withdraw>>
>;
export type WithdrawMutationBody = WithdrawalRequest;
export type WithdrawMutationError = unknown;

export const useWithdraw = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdraw>>,
    TError,
    { bankUid: string; productUid: string; data: WithdrawalRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof withdraw>>,
  TError,
  { bankUid: string; productUid: string; data: WithdrawalRequest },
  TContext
> => {
  const mutationOptions = getWithdrawMutationOptions(options);

  return useMutation(mutationOptions);
};
